module.exports = __webpack_public_path__ + "img/for-men-2.fb41c11.webp";